var _g, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsNewUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 275,
    viewBox: "0 0 269 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_936_5979_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.106347 0.255233 -0.255233 -0.106347 134.336 146.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    fill: "url(#paint0_diamond_936_5979)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_936_5979)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_936_5979)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_936_5979)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.336,
    cy: 146.858,
    r: 127.25,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"stopsVar\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"transform\":{\"m00\":-212.69454956054688,\"m01\":-510.46685791015625,\"m02\":495.91665649414062,\"m10\":510.46685791015625,\"m11\":-212.69454956054688,\"m12\":-2.0282552242279053},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.808594,
    y: 102.608,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.75,
    y: 119.109,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.75,
    y: 135.244,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.625,
    y: 124.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.625,
    y: 124.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.625,
    y: 124.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_5979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 0.60791,
    width: 54,
    height: 53,
    rx: 26.5,
    fill: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1 12.2422C139.645 12.2423 140.182 12.3676 140.667 12.6078C141.152 12.8479 141.57 13.196 141.887 13.6231L142.04 13.846L146.195 20.5192C146.605 21.1772 146.85 21.918 146.912 22.683L146.927 23.0678V38.6704C146.928 39.5038 146.601 40.3066 146.013 40.9177C145.425 41.5288 144.619 41.9031 143.756 41.9656L143.499 41.9739H119.499C118.634 41.9742 117.801 41.6594 117.167 41.0927C116.532 40.526 116.144 39.7492 116.079 38.9181L116.07 38.6704V23.0678C116.07 22.2996 116.256 21.5418 116.612 20.8545L116.804 20.5175L120.956 13.846C121.236 13.3954 121.624 13.0156 122.088 12.7384C122.551 12.4612 123.076 12.2945 123.62 12.2521L123.898 12.2422H139.1ZM143.499 23.8045H119.499V38.6704H143.499V23.8045ZM129.785 15.5457H123.898L120.812 20.501H129.785V15.5457ZM139.1 15.5457H133.213V20.501H142.186L139.1 15.5457Z",
    fill: "#10A37F"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4336,
    y: 188.608,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 127.375,
    y: 205.109,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 127.375,
    y: 221.244,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 210.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 93.25,
    y: 210.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105.25,
    y: 210.026,
    width: 16,
    height: 15,
    rx: 7.5,
    fill: "#10A37F",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_936_5979_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.336,
    cy: 146.858,
    r: 127.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_936_5979",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652065,
    stopColor: "#E8E9ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_5979"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 0.60791,
    width: 54,
    height: 53,
    rx: 26.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsNewUserIcon);
export default __webpack_public_path__ + "static/media/ProductsNewUserIcon.faa03c43830640f902960746ba8405f5.svg";
export { ForwardRef as ReactComponent };